export * from './hippo-company-logo';
